import Component from "@glimmer/component"
import type { FiscalGroup } from "@shared/models/fiscal-group"
import type { GroupMembership } from "@shared/models/group"
import { isUpgradedMembership } from "cc-frontend/utils/group"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembership
    fiscalGroup: FiscalGroup | null
  }
}

export default class GroupMembersTableUpgradedCellAdmin extends Component<Signature> {
  @tracked isHovering = false

  get isUpgraded() {
    return isUpgradedMembership(this.args.fiscalGroup, this.args.row)
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    GroupMembersTableUpgradedCellAdmin: typeof GroupMembersTableUpgradedCellAdmin
  }
}
